import { useState } from 'react';
import { toast } from 'react-toastify';
import {
  Box,
  Button,
  TextField
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';

interface EditPduInfoProps {
  onSubmit: () => void;
  pduId: string;
	ipAddress: string;
  pduName: string;
  description: string;
}

export const EditPduInfo = ({ onSubmit, pduId, ipAddress, pduName, description }: EditPduInfoProps) => {
  const api = useApi();

  const [newIPAddress, setNewIPAddress] = useState<string>(ipAddress);
  const [newPDUName, setNewPDUName] = useState<string>(pduName);
  const [newDescription, setNewDescription] = useState<string>(description);

  const editPduInfo = useMutation(api.editPduInfoApiV1EditPduInfoPost, {
    onSuccess() {
      toast.success('PDU Info edited successfully');
      onSubmit();
    },
    onError: apiError,
  });

  const hasChanges =
    newIPAddress !== ipAddress ||
    newPDUName !== pduName ||
    newDescription !== description;

  const handleSubmit = () => {
    editPduInfo.mutate({
			pdu_id: pduId,
			ip_addr: newIPAddress,
      pdu_name: newPDUName,
      description: newDescription,
		})
  };

  return (
    <Box pt={2}>
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="PDU Name"
        variant="outlined"
        value={newPDUName}
        onChange={(e) => setNewPDUName(e.target.value)}
        autoFocus
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="Description"
        variant="outlined"
        value={newDescription}
        onChange={(e) => setNewDescription(e.target.value)}
        autoFocus
      />
      <TextField
        sx={{ mb: 4 }}
        fullWidth
        label="IP address"
        variant="outlined"
        value={newIPAddress}
        onChange={(e) => setNewIPAddress(e.target.value)}
        autoFocus
      />
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={!hasChanges || editPduInfo.isLoading}>
          Save
        </Button>
      </Box>
    </Box>
  );
};
